import { render } from "./GeGHSObj.vue?vue&type=template&id=0495edf1"
import script from "./GeGHSObj.vue?vue&type=script&lang=js"
export * from "./GeGHSObj.vue?vue&type=script&lang=js"

import "./GeGHSObj.vue?vue&type=style&index=0&id=0495edf1&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__